import AllProduct from "./routes/Product/AllProduct.vue";
import DetailProduct from "./routes/Product/Detail.vue";
import Categories from "./routes/Categories/Categories.vue";
import ListCategoryProduct from "./routes/Categories/Detail.vue";
import FormCategory from "./routes/Categories/Form.vue";
import CategoryPromo from "./routes/CategoryPromo/CategoryPromo.vue";
import DetailCategoryPromo from "./routes/CategoryPromo/Detail.vue";

const productsRoutes = [
  {
    path: "all-product",
    name: "All-Product",
    component: AllProduct,
  },
  {
    path: "detail/:id",
    name: "Detail-Product",
    component: DetailProduct,
  },
  {
    path: "category-product",
    name: "Category-Product",
    component: Categories,
  },
  {
    path: "category/list-category-product/:id",
    name: "List-Category-Product",
    component: ListCategoryProduct,
  },
  {
    path: "category-product/add-category",
    name: "Add-Category",
    component: FormCategory,
  },
  {
    path: "category-product/edit-category/:id",
    name: "Edit-Category",
    component: FormCategory,
  },
  {
    path: "category-promo",
    name: "Category-Promo",
    component: CategoryPromo,
  },
  {
    path: "category-promo/detail/:id",
    name: "Detail-Category-Promo",
    component: DetailCategoryPromo,
  },
  {
    path: "category-promo/add",
    name: "Add-Category-Promo",
    component: DetailCategoryPromo,
  },
  {
    path: "category-promo/edit/:id",
    name: "Edit-Category-Promo",
    component: DetailCategoryPromo,
  },
];

export default productsRoutes;
